// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnitCard_unit-card__Fb1lN {
  width: 100%;
  background: white;
  min-height: 140px;
  height: 100%;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}
.UnitCard_unit-card__Fb1lN .UnitCard_unit-title__97C4s {
  width: 100%;
  margin-bottom: 5px !important;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.UnitCard_unit-card__Fb1lN .UnitCard_unit-title__97C4s p {
  font-weight: bold;
}
.UnitCard_unit-card__Fb1lN .UnitCard_unit-title__97C4s:hover p {
  color: var(--blue);
  text-decoration: underline;
  cursor: pointer;
}
.UnitCard_unit-card__Fb1lN .UnitCard_statistic__mGFfV {
  display: flex;
  align-items: center;
}
.UnitCard_unit-card__Fb1lN .UnitCard_statistic__mGFfV svg {
  width: 15px;
  height: 15px;
  margin-right: 10px;
}
.UnitCard_unit-card__Fb1lN .UnitCard_statistic__mGFfV svg path {
  stroke: var(--blue);
}
.UnitCard_unit-card__Fb1lN .UnitCard_statistic__mGFfV p {
  font-size: 12px;
}
.UnitCard_unit-card__Fb1lN .UnitCard_statistic__mGFfV span {
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Components/UnitCard/UnitCard.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;AACF;AAAE;EACE,WAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;AAEJ;AADI;EACE,iBAAA;AAGN;AACI;EACE,kBAAA;EACA,0BAAA;EACA,eAAA;AACN;AAEE;EACE,aAAA;EACA,mBAAA;AAAJ;AACI;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;AACN;AAAM;EACE,mBAAA;AAER;AACI;EACE,eAAA;AACN;AACI;EACE,gBAAA;AACN","sourcesContent":[".unit-card {\n  width: 100%;\n  background: white;\n  min-height: 140px;\n  height: 100%;\n  border-radius: 10px;\n  padding: 10px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  .unit-title {\n    width: 100%;\n    margin-bottom: 5px !important;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    p {\n      font-weight: bold;\n    }\n  }\n  .unit-title:hover {\n    p {\n      color: var(--blue);\n      text-decoration: underline;\n      cursor: pointer;\n    }\n  }\n  .statistic {\n    display: flex;\n    align-items: center;\n    svg {\n      margin-right: 5px;\n      width: 15px;\n      height: 15px;\n      margin-right: 10px;\n      path {\n        stroke: var(--blue);\n      }\n    }\n    p {\n      font-size: 12px;\n    }\n    span {\n      font-weight: 600;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unit-card": `UnitCard_unit-card__Fb1lN`,
	"unit-title": `UnitCard_unit-title__97C4s`,
	"statistic": `UnitCard_statistic__mGFfV`
};
export default ___CSS_LOADER_EXPORT___;
